// Auto-generated by the generator
// Don't manually edit this file

// @flow

import type {Action} from '../../types'
import type {SessionState} from '../types'

import {setReadyReducer} from './setReady'
import {setUserReducer} from './setUser'
import {setErrorReducer} from './setError'
import {setLoadingReducer} from './setLoading'
import {initialState} from './initialState'

export const sessionReducer = (state: SessionState = initialState, action: Action<any>): SessionState => {
  switch (action.type) {
    case 'session/SET_READY':
      return setReadyReducer(state, action)
    case 'session/SET_USER':
      return setUserReducer(state, action)
    case 'session/SET_ERROR':
      return setErrorReducer(state, action)
    case 'session/SET_LOADING':
      return setLoadingReducer(state, action)
    default:
      return state
  }
}
